import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { UserState } from '@coin/shared/auth/feature';
import { MeritBudgetAllocationState } from '../../merit-budget-allocation/store/merit-budget-allocation.state';
import { MeritAllocationGeneralService } from './merit-allocation-general.service';
import { MeritAllocationImpersonatedEmployeeService } from './merit-allocation-impersonated-employee.service';

@Injectable({ providedIn: 'root' })
export class AllocationUserOrgCodeService {
  private readonly meritAllocationGeneralService = inject(MeritAllocationGeneralService);
  private readonly userState = inject(UserState);
  private readonly meritAllocationImpersonatedEmployeeService = inject(MeritAllocationImpersonatedEmployeeService);
  private readonly meritBudgetAllocationState = inject(MeritBudgetAllocationState);

  private userOrgCode: string;
  private userOrgCodeKey: string;

  /**
   * Returns the primary org code of the user's (or impersonated employee's) record in the selected season
   */
  public getUserOrgCode(): Observable<string> {
    const employeeId = this.meritAllocationImpersonatedEmployeeService.employeeId || this.userState.user().id;
    const seasonId = this.meritBudgetAllocationState.season().id;
    const key = `${seasonId}:${employeeId}`;

    if (this.userOrgCode && this.userOrgCodeKey === key) {
      return of(this.userOrgCode);
    }

    return this.loadAndStoreUserOrgCode(employeeId, seasonId, key);
  }

  private loadAndStoreUserOrgCode(employeeId: string, seasonId: string, key: string): Observable<string> {
    return this.meritAllocationGeneralService.getEmployeeSnapshotById(seasonId, employeeId).pipe(
      map(employee => employee?.paOrgCode),
      tap(orgCode => {
        this.userOrgCode = orgCode;
        this.userOrgCodeKey = key;
      })
    );
  }
}
